/* eslint-disable @typescript-eslint/return-await */
import { AxiosResponse } from "axios";

import API from "../api";
import { UserCompany } from "../models/user.company";

const ROUTE_NAME = "profile/users/companies";

const UserCompanyService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<any>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<UserCompany[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(agent: any): Promise<AxiosResponse<any>> {
    return await API.post(`/${ROUTE_NAME}`, agent);
  },
  async update(id: number, agent: any): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, agent);
  },
  async delete(id: number): Promise<AxiosResponse<any>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
};

export default UserCompanyService;
